import { render, staticRenderFns } from "./DoctorSelect.vue?vue&type=template&id=7ec2b67a&scoped=true"
import script from "./DoctorSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSelect.vue?vue&type=script&lang=js"
import style0 from "./DoctorSelect.vue?vue&type=style&index=0&id=7ec2b67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2b67a",
  null
  
)

export default component.exports